export default "__VITE_ASSET__BVofnFPE__"